module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_forceReduced.js
// module id = ../../node_modules/ramda/src/internal/_forceReduced.js
// module chunks = 18